import { useLocalSearchParams } from 'expo-router'

import { AceptInviteScreen } from '@/screens/acept-invite/AceptInviteScreen'

export default function () {
  const { code } = useLocalSearchParams<{ code: string }>()

  return <AceptInviteScreen code={code} />
}
